import { load } from '@fingerprintjs/fingerprintjs';

export const FINGER_PRINT_KEY = 'fingerPrint';

export class GetFingerPrint {
  private _value: string | undefined = undefined;
  private failCount = 0;
  private _loadingPromise: Promise<string | undefined> | null = null;

  constructor() {
    const fingerPrint = typeof window === 'undefined' ? '' : localStorage.getItem(FINGER_PRINT_KEY);

    if (fingerPrint) {
      this._value = fingerPrint;
    } else {
      this._loadingPromise = load()
        .then((fpAgent) => fpAgent.get())
        .then((data) => {
          typeof window !== 'undefined'
            ? localStorage.setItem(FINGER_PRINT_KEY, data.visitorId)
            : null;

          this._value = data.visitorId;

          return data.visitorId;
        })
        .catch(() => {
          this.failCount++;

          return undefined;
        });
    }
  }

  async getValueAsync(timeout = 3000): Promise<string | undefined> {
    console.log('[FP-DEBUG] getValueAsync called', {
      _value: this._value,
      hasPromise: !!this._loadingPromise
    });

    if (this._value) {
      console.log('[FP-DEBUG] return from _value');

      return this._value;
    }

    const fingerPrint = typeof window === 'undefined' ? '' : localStorage.getItem(FINGER_PRINT_KEY);

    if (fingerPrint) {
      this._value = fingerPrint;
      console.log('[FP-DEBUG] return from localStorage', fingerPrint);

      return this._value;
    }

    if (this._loadingPromise) {
      console.log('[FP-DEBUG] waiting for loadingPromise...');
      const timeoutPromise = new Promise<undefined>((resolve) =>
        setTimeout(() => {
          console.log('[FP-DEBUG] timeout reached!');
          resolve(undefined);
        }, timeout)
      );

      const result = await Promise.race([this._loadingPromise, timeoutPromise]);

      console.log('[FP-DEBUG] Promise.race result:', result);

      return result;
    }

    console.log('[FP-DEBUG] no promise, return undefined');

    return undefined;
  }

  get value(): string | undefined {
    if (this._value) {
      return this._value;
    }

    const fingerPrint = typeof window === 'undefined' ? '' : localStorage.getItem(FINGER_PRINT_KEY);

    if (fingerPrint) {
      this._value = fingerPrint;

      return this._value;
    }

    if (this.failCount < 100) {
      load()
        .then((fpAgent) => fpAgent.get())
        .then((data) => {
          typeof window !== 'undefined'
            ? localStorage.setItem(FINGER_PRINT_KEY, data.visitorId)
            : null;
          this._value = data.visitorId;
          this.failCount = 0;
        })
        .catch(() => {
          this.failCount++;
        });
    }

    return undefined;
  }
}
